import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";
import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import { SaveResponse, IResourceLibrary } from "services/KnowfullyAdminClient";

import ResourceLibraryItemForm, {
  SaveResourceLibraryItemRequest,
} from "./ResourceLibraryItemForm";

type ResourceLibraryCreateFormProps = {
  resourceLibrary: IResourceLibrary;
  onResourceLibraryItemCreated: (
    createdResourceLibraryItem: SaveResponse
  ) => void;
  onCancel: () => void;
};

const ResourceLibraryCreateForm = ({
  onResourceLibraryItemCreated,
  onCancel,
  resourceLibrary,
}: ResourceLibraryCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();

  const onSubmit = (values: SaveResourceLibraryItemRequest) => {
    const {
      description,
      file,
      name,
      publicationDate,
      resourceLibraryTypeId,
      resourceLibraryId,
      sequence,
    } = values;

    return registerPromise(
      resourceLibraryService.saveResourceLibraryItem(
        resourceLibraryId,
        null,
        resourceLibraryTypeId,
        name,
        publicationDate,
        description,
        sequence,
        file,
        null
      )
    )
      .then((createdResourceLibrary) => {
        onResourceLibraryItemCreated(createdResourceLibrary);
      })
      .catch((err: any) => {
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ResourceLibraryItemForm
      resourceLibrary={resourceLibrary}
      onSubmit={onSubmit}
      submitLabel={t({ id: "resourceLibraryFormCreateItemButton" })}
      onCancel={onCancel}
      isInsert={true}
    />
  );
};

export default ResourceLibraryCreateForm;
